import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({
  title,
  description,
  keywords,
  ogImage,
  ogType = 'website',
  canonical,
  noindex = false,
  lang = 'ko',
}) => {
  const baseUrl = 'https://www.aidu.kr';
  const defaultImage = `${baseUrl}/aidu-logo.svg`;
  const fullTitle = title ? `${title} | Aidu` : 'Aidu - AI-Powered Educational Platform';
  const fullDescription = description || 'Transform education with AI-powered learning tools. Circuit Training, Problem Bank Manager, Analytics Dashboard, and Student Management for Korean schools.';
  const canonicalUrl = canonical ? `${baseUrl}${canonical}` : baseUrl;
  const image = ogImage ? `${baseUrl}${ogImage}` : defaultImage;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <html lang={lang} />
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={fullDescription} />
      {keywords && <meta name="keywords" content={keywords} />}
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      
      {/* Canonical URL */}
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={fullDescription} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="Aidu" />
      <meta property="og:locale" content={lang === 'ko' ? 'ko_KR' : 'en_US'} />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={canonicalUrl} />
      <meta property="twitter:title" content={fullTitle} />
      <meta property="twitter:description" content={fullDescription} />
      <meta property="twitter:image" content={image} />

      {/* Additional Meta Tags */}
      <meta name="author" content="Aidu" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
      
      {/* Structured Data for Organization */}
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'Organization',
          name: 'Aidu',
          url: baseUrl,
          logo: `${baseUrl}/aidu-logo.svg`,
          description: 'AI-powered educational platform for Korean schools',
          contactPoint: {
            '@type': 'ContactPoint',
            email: 'admin@aidu.kr',
            contactType: 'Customer Service',
          },
          sameAs: [
            // Add social media links when available
          ],
        })}
      </script>
    </Helmet>
  );
};

export default SEO;

